import defaultConsumerImageSrc from "./default_consumer.svg";
import defaultPartnerImageSrc from "./default_partner.svg";

export { defaultConsumerImageSrc, defaultPartnerImageSrc };
